import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for N202 (客訴處理記錄單-採購)
// ============================================================

export interface FN110 {
  fn110_01: string;          // 客訴單號 (PK, auto-generated)
  fn110_11: string | null;   // 客訴日期 (ISO string)
  fn110_22: string;          // 部門代碼
  fn110_23: number;          // 記錄型態 1=待確認/2=採購/3=業務+採購
  fn110_132: string;         // 建立者
  fn110_28: string;          // 採購處理說明 (textarea)
  fn110_35: number;          // Page4 count
  fn110_36: number;          // Page5 count
  fn110_37: number;          // Page6 count
  // 廠商一
  fn110_41: string;          // 廠商一代號
  fn110_42: string;          // 廠商一幣別
  fn110_43: number;          // 廠商一匯率
  fn110_44: number;          // 廠商一貨款抵扣
  fn110_45: number;          // 廠商一進貨退款
  fn110_46: number;          // 廠商一退款
  fn110_451: string;         // 廠商一抵扣類型
  fn110_452: string;         // 廠商一抵扣參考單號
  fn110_461: string;         // 廠商一退款類型
  fn110_462: string;         // 廠商一退款參考單號
  fn110_48: number;          // 廠商一明細筆數
  fn110_47: string;          // 廠商一備註
  fn110_49: string;          // 廠商一採購人員
  fn110_221: string;         // 廠商一採購人員部門
  // 廠商二
  fn110_51: string;
  fn110_52: string;
  fn110_53: number;
  fn110_54: number;
  fn110_55: number;
  fn110_56: number;
  fn110_551: string;
  fn110_552: string;
  fn110_561: string;
  fn110_562: string;
  fn110_57: string;          // 廠商二備註
  fn110_58: number;
  fn110_59: string;
  fn110_222: string;
  // 廠商三
  fn110_61: string;
  fn110_62: string;
  fn110_63: number;
  fn110_64: number;
  fn110_65: number;
  fn110_66: number;
  fn110_651: string;
  fn110_652: string;
  fn110_661: string;
  fn110_662: string;
  fn110_67: string;          // 廠商三備註
  fn110_68: number;
  fn110_69: string;
  fn110_223: string;
  // 關聯業務客訴單號
  fn110_71: string;
  fn110_72: string;
  fn110_73: string;
  fn110_74: string;
  fn110_75: string;
  // 核准/作廢旗標
  fn110_80: boolean;          // 業務核准
  fn110_801: boolean;         // 作廢
  fn110_802: string;          // 業務核准者
  fn110_803: string | null;   // 業務核准日期
  fn110_81: boolean;          // 採購核准
  fn110_811: boolean;         // 採購作廢
  fn110_812: string;          // 採購核准者
  fn110_813: string | null;   // 採購核准日期
  fn110_82: boolean;          // 副總核准
  fn110_84: boolean;          // 結案旗標
  // 版本/修改資訊
  fn110_90: number;           // 版本
  fn110_91: string;           // 修改人
  fn110_92: string | null;    // 修改日
  fn110_93: string;           // 修改備註

  // Associations
  vendor1_reasons?: FN1121[];
  vendor2_reasons?: FN1122[];
  vendor3_reasons?: FN1123[];
  receipt_details?: FN114[];
  messages?: FN116[];
  attachments?: FN117[];
}

export interface FN1121 {
  fn1121_01: string;   // FK to FN110_01
  fn1121_02: number;   // 序號
  fn1121_11: string;   // 原因代碼
  fn1121_12: string;   // 幣別（FoxPro 由 FN110_42 帶入）
  fn1121_13: number;   // 匯率（FoxPro 由 FN110_43 帶入）
  fn1121_14: number;   // 金額
  fn1121_90: number;
  fn1121_91: string;
  fn1121_92: string | null;
  fn1121_93: string;
}

export interface FN1122 {
  fn1122_01: string;
  fn1122_02: number;
  fn1122_11: string;
  fn1122_12: string;   // 幣別（FoxPro 由 FN110_52 帶入）
  fn1122_13: number;   // 匯率（FoxPro 由 FN110_53 帶入）
  fn1122_14: number;
  fn1122_90: number;
  fn1122_91: string;
  fn1122_92: string | null;
  fn1122_93: string;
}

export interface FN1123 {
  fn1123_01: string;
  fn1123_02: number;
  fn1123_11: string;
  fn1123_12: string;   // 幣別（FoxPro 由 FN110_62 帶入）
  fn1123_13: number;   // 匯率（FoxPro 由 FN110_63 帶入）
  fn1123_14: number;
  fn1123_90: number;
  fn1123_91: string;
  fn1123_92: string | null;
  fn1123_93: string;
}

/* superseded legacy Web-only receipt shape
export interface FN114 {
  fn114_01: string;    // FK to FN110_01
  fn114_02: number;    // 序號
  fn114_11: string;    // 入庫單號
  fn114_12: number;    // 入庫項次
  fn114_13: string;    // 類型 D/E
  fn114_21: number;    // 數量
  fn114_14: string;    // 產品代號 S/N
  fn114_15: number;    // 繳庫量
  fn114_16: number;    // 金額(繳庫)
  fn114_22: number;    // 金額
  fn114_51: string;    // 廠商代碼
  fn114_90: number;
  fn114_91: string;
  fn114_92: string | null;
  fn114_93: string;
  // Sub-detail
  colors?: FN115[];
}

export interface FN115 {
  fn115_01: string;    // FK to FN110_01
  fn115_02: number;    // FK to FN114_02
  fn115_03: number;    // 序號
  fn115_11: string;    // 色號代碼
  fn115_12: string;    // 色號名稱
  fn115_14: number;    // 金額
  fn115_90: number;
  fn115_91: string;
  fn115_92: string | null;
  fn115_93: string;
}

*/

export interface FN114 {
  fn114_01: string;
  fn114_02: number;
  fn114_11: string;
  fn114_12: number;
  fn114_13: number;
  fn114_14: string;
  fn114_15: number;
  fn114_16: number;
  fn114_17: string;
  fn114_18: string;
  fn114_19: string | null;
  fn114_20: string | null;
  fn114_21: string | null;
  fn114_22: number;
  fn114_23: string;
  fn114_31: string;
  fn114_311: string;
  fn114_312: string;
  fn114_32: number;
  fn114_51: string;
  fn114_90: number;
  fn114_91: string;
  fn114_92: string | null;
  fn114_93: string;
  colors?: FN115[];
}

export interface FN115 {
  fn115_01: string;
  fn115_02: number;
  fn115_03: number;
  fn115_11: string;
  fn115_12: string;
  fn115_13: string;
  fn115_14: number;
  fn115_90: number;
  fn115_91: string;
  fn115_92: string | null;
  fn115_93: string;
}

export interface FN116 {
  fn116_01: string;    // FK to FN110_01
  fn116_02: number;    // 序號
  fn116_11: string;    // 員工代碼
  fn116_12: string;    // 員工姓名
  fn116_03: string;    // 傳送備註
  fn116_21: string;    // 留言內容
  fn116_22: string | null; // 傳送日期
  fn116_23: string;    // 傳送時間
  fn116_90: number;
  fn116_91: string;
  fn116_92: string | null;
  fn116_93: string;
}

export interface FN117 {
  fn117_01: string;    // FK to FN110_01
  fn117_02: number;    // 序號
  fn117_11: string;    // 檔案名稱
  fn117_21: number;    // 檔案類型 1=Word,2=Excel,3=PPT,4=HTML,5=PDF
  fn117_22: string;    // 檔案路徑
  fn117_90: number;
  fn117_91: string;
  fn117_92: string | null;
  fn117_93: string;
}

// ============================================================
// Request / Response types
// ============================================================

export interface N202ListResponse {
  data: FN110[];
  total: number;
  page: number;
  size: number;
}

export interface N202CreateRequest {
  master: Partial<FN110>;
  vendor1_reasons: Partial<FN1121>[];
  vendor2_reasons: Partial<FN1122>[];
  vendor3_reasons: Partial<FN1123>[];
  receipt_details: Partial<FN114>[];
  messages: Partial<FN116>[];
  attachments: Partial<FN117>[];
}

export interface N202UpdateRequest {
  master: Partial<FN110>;
  vendor1_reasons: Partial<FN1121>[];
  vendor2_reasons: Partial<FN1122>[];
  vendor3_reasons: Partial<FN1123>[];
  receipt_details: Partial<FN114>[];
  messages: Partial<FN116>[];
  attachments: Partial<FN117>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const n202Api = {
  async list(page = 1, size = 20): Promise<N202ListResponse> {
    const res = await apiClient.get('/api/n202', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FN110> {
    const res = await apiClient.get(`/api/n202/${encodeURIComponent(id)}`);
    return res.data;
  },

  async previewReceiptDetail(documentNo: string, lineNo: number): Promise<FN114> {
    const res = await apiClient.get(`/api/n202/from-receipt/${encodeURIComponent(documentNo)}/line/${lineNo}`);
    return res.data;
  },

  async create(data: N202CreateRequest): Promise<FN110> {
    const res = await apiClient.post('/api/n202', data);
    return res.data;
  },

  async update(id: string, data: N202UpdateRequest): Promise<FN110> {
    const res = await apiClient.put(`/api/n202/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/n202/${encodeURIComponent(id)}`);
  },

  // ── Approval workflow ──

  async submitForApproval(id: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/n202/${encodeURIComponent(id)}/submit`, { comment: comment || '' });
    return res.data;
  },

  async approve(id: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/n202/${encodeURIComponent(id)}/approve`, { comment: comment || '' });
    return res.data;
  },

  async reject(id: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/n202/${encodeURIComponent(id)}/reject`, { comment: comment || '' });
    return res.data;
  },

  async writeoff(id: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`/api/n202/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  async getApprovalHistory(id: string): Promise<ApprovalHistory[]> {
    const res = await apiClient.get(`/api/n202/${encodeURIComponent(id)}/approval-history`);
    return res.data.data || [];
  },
};

// ============================================================
// Approval types
// ============================================================

export interface ApprovalHistory {
  id: number;
  order_no: string;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}
